import { useTranslation } from 'react-i18next';
import { Modal } from '@seeqdev/qomponents';
import type { ReactElement } from 'react';

type UnsavedChangesModalProps = {
  onCancel: () => void;
  onDiscard: () => void;
  /** translation key for the message explaining what will be discarded */
  messageKey: string;
};

/**
 * Asks the user to confirm that they want to throw away their unsaved changes.
 */
export const UnsavedChangesModal = ({ onCancel, onDiscard, messageKey }: UnsavedChangesModalProps): ReactElement => {
  const { t } = useTranslation();

  return (
    <Modal
      open={true}
      title={t('UNSAVED_CHANGES_MODAL.HEADER')}
      onClose={onCancel}
      submitButtonLabel={t('UNSAVED_CHANGES_MODAL.DISCARD')}
      onSubmit={onDiscard}
      size="lg"
      cancelButtonLabel={t('CANCEL')}>
      {t(messageKey)}
    </Modal>
  );
};
